if (!customElements.get("collection-bestsellers")) {

  class CollectionBestsellers extends HTMLElement {
    busy = false;
    aborter = null;
    raf = 0;

    connectedCallback() {
      this.hydrate();
      document.addEventListener("on:facet-filters:updated", this.onUpdated);
    }

    disconnectedCallback() {
      document.removeEventListener("on:facet-filters:updated", this.onUpdated);
      if (this.raf) cancelAnimationFrame(this.raf);
      this.aborter?.abort();
    }

    onUpdated = () => {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(this.hydrate);
    };

    hydrate = async () => {
      if (this.busy) return;

      const sort =
        new URL(location.href).searchParams.get("sort_by") || "featured";
      if (sort === "best-selling") return;

      const carousel = this.querySelector("[data-bestsellers-carousel]");
      if (!carousel) return;

      if (
        carousel.dataset.bestsellersHydrated === "1" &&
        carousel.dataset.lastHydratedSort === sort
      ) return;

      const sectionId = carousel.dataset.fetchSectionId;
      if (!sectionId) return;

      this.aborter?.abort();
      this.aborter = new AbortController();


      this.busy = true;
      this.setAttribute("data-loading", "1");


      try {
        const url = new URL(location.href);
        url.searchParams.set("sort_by", "best-selling");
        url.searchParams.set("filter.v.availability", "1");
        url.searchParams.set("sections", sectionId);

        const res = await fetch(url.href, {
          credentials: "same-origin",
          signal: this.aborter.signal,
        });

        const json = await res.json();
        const html = json?.[sectionId];
        if (!html) return;

        const doc = new DOMParser().parseFromString(html, "text/html");
        const fresh = doc.querySelector("[data-bestsellers-carousel]");
        if (!fresh) return;

        carousel.innerHTML = fresh.innerHTML;

        carousel.refresh?.() || carousel.init?.();

        carousel.dataset.bestsellersHydrated = "1";
        carousel.dataset.lastHydratedSort = sort;
      } catch (e) {
        if (e?.name !== "AbortError")
          console.error("Bestsellers error:", e);
      } finally {
        this.removeAttribute("data-loading");
        this.busy = false;
      }
    }
  }

  customElements.define("collection-bestsellers", CollectionBestsellers);
}